export const API_LINK = process.env.NODE_ENV === 'production' ? 'https://api.' + window.location.hostname + '/' : 'https://api.tool.peeringhub.io/';

export const DECRYPT_CERTIFICATE = 'api/decrypt_sti_certificate';
export const GENERATE_TOKEN = 'api/generate_sti_token';
export const VERIFY_TOKEN = 'api/verify_sti_token';
